export const RESTOCK_NOTIFICATION_SUCCEEDED_IMAGE_URL =
  'https://cf.image-farm.s.zigzag.kr/original/cms/2025/07/02/202507022327388462_072050.png';
export const RESTOCK_NOTIFICATION_FAILED_IMAGE_URL =
  'https://cf.image-farm.s.zigzag.kr/original/cms/2025/07/02/202507022328192862_047489.png';

export const LOCK_ICON = 'https://cf.image-farm.s.zigzag.kr/original/cms/2025/02/18/202502180049264905_068054.png';
